export default __webpack_public_path__ + "static/media/gallery_00.44a0f156.jpg";